import { useDispatch, useSelector } from "react-redux";
import RequestDetails from "./RequestDetails";
import { useCallback, useEffect, useState } from "react";
import CostCenterDispatch from "Store/AssetManagement/CostCenter/CostCenterDispatch";
import { CONSTANTS } from "client/utils/constants";
import { setDispositionData, setInitialDispositionData, setTransferData} from "Store/OrderManagement/FleetProcessing/FleetProcessingAction";
import LocationValidation from '../../Asset/TransferOrder/CreateNewRequisition/Disposition/dispositionValidation'
import DispositionValidation from '../../Asset/TransferOrder/CreateNewRequisition/Disposition/DispositionSubChoices/dispositionSubChoicesValidation'
import { v1 as uuid } from "uuid";
import { getDispositionSubChoice } from "Store/OrderManagement/DispositionChoice/DispositionChoiceAction";
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { saveOrderAttachments, setAttachmentList, setRecevingCostCenterOption } from "Store/Component/FleetManagement/FleetManagementAction";
import { formatPrice, getFileName } from "utils";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import { getCostCenters } from "Store/Organization/CostCenters/CostCentersAction";
import { getAddressDetails } from "Store/Organization/AutoCompleteAddressDetails/AddressDetailsAction";
import { getAddressDropDownList, setAddressDropDownList } from "Store/Organization/AutoCompleteAddressSearch/AddressSearchAction";
import { getAfeFleetHeaderDetail, getAssetFleetHeaderDetail, setAfeFleetHeaderDetail, setAssetOrderHeaderDetail } from "Store/FleetManagement/AssetFleetProcessing/AssetFleetProcessingAction";
import { getDispositionChoice } from "Store/OrderManagement/DispositionChoice/DispositionChoiceAction";

const choices = [CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED, CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED, undefined, null, ""]

const RequestDetailsContainer = (props: any) => {
    const { setIsChnagedOccuredFlag } = props
    const id = props?.id
    const dispatch = useDispatch();
    const thirdPartyChoices = [CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY, CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY]
    const FMCAuctionChoices = [CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED, CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED]

    const {
        getUserDetails,
        branchTypeDropdown,
        dispositionChoiceList,
        reasonCodeList,
        stateList,
        cityList,
        dispositionSubChoiceList,
        assetDisposition,
        docList,
        attachmentsList,
        linkedAttachments,
        receivingCostCenterOption,
        costCenterWithDivisionId,
        savedStatus,
        addressDropDownList,
        locationAddressDetails,
        assetOrderHeaderDetail,
        assetFleetHeaderDetail,
        afeFleetHeaderDetail
    }: any = useSelector((state: any) => ({
        getUserDetails: state.UserProfile.getUserDetails,
        branchTypeDropdown: state.CostCenter.costCenterDropDown,
        dispositionChoiceList: state.DispositionChoiceReducer.dispositionChoiceList,
        reasonCodeList: state.ReasonCodeReducer.reasonCodeList,
        stateList: state.StatesReducer.statesDropDownList,
        cityList: state.CitiesReducer.citiesDropDownList,
        dispositionSubChoiceList: state.DispositionChoiceReducer.dispositionSubChoiceList,
        assetDisposition: state.FleetProcessingReducer.dispositionData,
        docList: state.UploadAttachmentsReducer.list,
        attachmentsList: state.fleetAdminTaskReducer.attachmentList,
        linkedAttachments: state.fleetAdminTaskReducer.linkedAttachments,
        savedStatus: state.adminTaskReducer.savedStatus,
        receivingCostCenterOption: state.fleetAdminTaskReducer.receivingCostCenterOption,
        costCenterWithDivisionId: state.CostCentersReducer.costCenterWithDivisionId,
        addressDropDownList: state.AddressDropDownReducer.addressDropDownList,
        locationAddressDetails: state.AddressDetailReducer.addressDetails,
        assetOrderHeaderDetail: state.AssetFleetProcessingReducer.assetOrderHeaderDetail,
        assetFleetHeaderDetail: state.AssetFleetProcessingReducer.assetFleetHeaderDetail,
        afeFleetHeaderDetail: state.AssetFleetProcessingReducer.afeFleetHeaderDetail
    }))

    const [currentType, setCurrentType] = useState<any>();
    const [addressDropDownListTemp, setAddressDropDownListTemp] = useState<any>();
    const [addressListLoad, setAddressListLoad] = useState<any>();
    const [addressSearchText, setAddressSearchText] = useState<any>();
    const [branchValue, setBranchValue] = useState<any>('');
    const [reasonCodeDropdownList, setReasonCodeDropdownList] = useState<any>([]);
    const [dispositionChoiceDropdownList, setDispositionChoiceDropdownList] = useState<any>([]);
    const [stateDropdownList, setStateDropdownList] = useState<any>([]);
    const [cityDropdownList, setCityDropdownList] = useState<any>([]);
    const [dispositionSubChoiceDropdownList, setDispositionSubChoiceDropdownList] = useState<any>([]);
    const [sameAsBranch, setSameAsBranch] = useState<boolean>(false)
    const [assetDispositionTemp, setAssetDispositionTemp] = useState<any>();
    const [attachmentError, setAttachmentError] = useState<string>("");
    const [documentList, setDocumentList] = useState<any>([]);
    const [iAttachmentEditable, setIsAttachmentEditable] = useState<any>();
    const dispatchBranchDropdown = CostCenterDispatch.dispatchGetCostCenter(dispatch);
    const dispatchUploadAttachments = UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch);
    const dispatchRemoveAttachment = UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);

    const processTypeOptions = [
        { value: 'REM', label: 'REM' },
        { value: 'Fleet', label: 'Fleet' }
    ]

    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comments: "",
    });

    const [updateOrderAttachments, setUpdateOrderAttachments] = useState<boolean>(false)

    useEffect(() => {
        dispatch(setAddressDropDownList([]));
    }, [])

    useEffect(() => {
        if (addressDropDownList?.length) {
            const addDropdownList = addressDropDownList?.map((item: any, index: number) =>
                ({ text: item.description, label: item.description, value: item.place_id, key: item.place_id })
            );
            setAddressDropDownListTemp(addDropdownList)

        }
        setAddressListLoad(false)
    }, [addressDropDownList])

    useEffect(() => {
        if (assetDisposition) {
            setAssetDispositionTemp(JSON.parse(JSON.stringify(assetDisposition)))
        }
    }, [assetDisposition])

    useEffect(() => {
        if (assetFleetHeaderDetail?.length) {
            const assetOrderDetailsTemp = assetOrderHeaderDetail ? JSON.parse(JSON.stringify(assetOrderHeaderDetail)) : [];
            const assetFleetHeaderDetailTemp = assetFleetHeaderDetail ? JSON.parse(JSON.stringify(assetFleetHeaderDetail)) : [];
            assetFleetHeaderDetailTemp?.map((fleetDetail?: any) => {
                assetOrderDetailsTemp?.fleetRequestDetail?.map((request: any, index: any) => {
                    request?.fleetAssetDetails?.map((itemLevel: any) => {
                        if (fleetDetail?.fleetRequestDetailId == itemLevel?.fleetRequestDetailId) {
                            itemLevel.assetNo = fleetDetail?.assetNo
                            itemLevel.description = fleetDetail?.description
                            itemLevel.fleetRequestDetailId = fleetDetail?.fleetRequestDetailId
                            itemLevel.fleetStatus = fleetDetail?.fleetStatus
                            itemLevel.itemStatus = fleetDetail?.itemStatus
                            itemLevel.orderRequestId = fleetDetail?.orderRequestId
                            itemLevel.itemNumber = fleetDetail?.itemNumber
                            itemLevel.alreadyReturnedFromFleet = fleetDetail?.alreadyReturnedFromFleet
                        }
                    })
                })
            })
            dispatch(setAssetOrderHeaderDetail(assetOrderDetailsTemp))
        }
    }, [assetFleetHeaderDetail])

    useEffect(() => {
        if (afeFleetHeaderDetail?.length) {
            const afeFleetHeaderDetailTemp = afeFleetHeaderDetail ? JSON.parse(JSON.stringify(afeFleetHeaderDetail)) : [];
            const arr:any = []
            afeFleetHeaderDetailTemp.map((item: any) => {
                arr.push({
                    fleetAssetDetails: [item]
            })
            })
            dispatch(setTransferData(arr));
        }
    }, [afeFleetHeaderDetail])

    useEffect(() => {
        if (assetOrderHeaderDetail?.fleetRequestDetail?.length && id == assetOrderHeaderDetail?.orderRequestId) {
            if (!assetFleetHeaderDetail?.length) {
                dispatch(getAssetFleetHeaderDetail(id))
            } else {
                const assetOrderDetailsTemp = assetOrderHeaderDetail ? JSON.parse(JSON.stringify(assetOrderHeaderDetail)) : [];
                const arr = [
                    ...assetOrderDetailsTemp.fleetRequestDetail.map((item: any) => {
                        if (item) {
                            return {
                                ...item
                            };
                        }
                    }),
                ];
                dispatch(setTransferData(arr));

                if (assetOrderDetailsTemp?.orderRequestType == CONSTANTS.TRANSFER) {
                    let costCenterOptionTemp: any = []
                    assetOrderDetailsTemp?.fleetRequestDetail?.map((request: any, requestindex: any) => {
                        if (request?.transferReceivingBranch?.divisionId) {
                            let obj: any = {}
                            obj.divisionId = request?.transferReceivingBranch?.divisionId
                            obj.options = []
                            costCenterOptionTemp?.push(obj)
                            dispatch(setRecevingCostCenterOption(costCenterOptionTemp))
                            dispatch(getCostCenters(request?.transferReceivingBranch?.divisionId))
                        }
                    })
                }
            }
        } else if (assetOrderHeaderDetail?.orderRequestType == CONSTANTS.AFEREQUEST) {
            if(!afeFleetHeaderDetail?.length){ 
                dispatch(getAfeFleetHeaderDetail(id))
            }else {
                const afeFleetHeaderDetailTemp = afeFleetHeaderDetail ? JSON.parse(JSON.stringify(afeFleetHeaderDetail)) : [];
                const arr:any = []
                afeFleetHeaderDetailTemp.map((item: any) => {
                    arr.push({
                        fleetAssetDetails: [item]
                    })
                })
                dispatch(setTransferData(arr));
            }
        } else {
            dispatch(setTransferData([]));
        }
    }, [assetOrderHeaderDetail]);

    useEffect(() => {
        let receivingCostCenterOptionTemp = receivingCostCenterOption?.length ? receivingCostCenterOption : []
        if (receivingCostCenterOptionTemp) {
            receivingCostCenterOptionTemp?.map((optionItem?: any, optionIndex?: any) => {
                if (optionItem?.divisionId == costCenterWithDivisionId?.id?.divisionId) {
                    optionItem.options = costCenterWithDivisionId?.option
                }
            })
            dispatch(setRecevingCostCenterOption(receivingCostCenterOptionTemp))
        }
    }, [costCenterWithDivisionId])

    useEffect(() => {
        if (getUserDetails?.emailId) {
            dispatchBranchDropdown(getUserDetails?.emailId);
        }
    }, [getUserDetails?.emailId])

    useEffect(() => {
        const tempList = dispositionChoiceList?.map((item: any) =>
            ({ label: item.text, key: item.value, ...item })
        );
        setDispositionChoiceDropdownList(tempList)
    }, [dispositionChoiceList])

    useEffect(() => {
        const tempList = reasonCodeList?.map((item: any) =>
            ({ label: item.text, key: item.value, ...item })
        );
        setReasonCodeDropdownList(tempList)
    }, [reasonCodeList])

    useEffect(() => {
        const tempList = stateList?.map((item: any) =>
            ({ label: item.text, key: item.value, ...item })
        );
        setStateDropdownList(tempList)
    }, [stateList])

    useEffect(() => {
        const tempList = cityList?.map((item: any) =>
            ({ label: item.text, key: item.value, ...item })
        );
        setCityDropdownList(tempList)
    }, [cityList])

    useEffect(() => {
        if(dispositionSubChoiceList?.length > 0){
            const tempList = dispositionSubChoiceList?.map((item: any) =>
                ({ label: item.text, key: item.value, ...item })
            );
            setDispositionSubChoiceDropdownList(tempList)

            if(assetDisposition?.assetDispositionSubChoiceId != null){
                assetOrderHeaderDetail?.fleetRequestDetail?.map((item: any, index: any) => {
                    const disposition = item?.assetDisposition;
                    const assetDispositionChoice = getSelectedDispositionChoice(disposition?.dispositionChoice)
                    if (choices.includes(assetDispositionChoice)) {
                        dispatch(setDispositionData({ ...assetDisposition, assetDispositionSubChoice: disposition?.sellToLeasedText, assetDispositionSubChoiceId: disposition?.value}))
                    }
                })
            }
        }
    }, [dispositionSubChoiceList])

    useEffect(() => { 
        if(assetOrderHeaderDetail?.hasOwnProperty('orderRequestId')){     
        setBranchValue(assetOrderHeaderDetail?.costCenter);
        let orderAttachment = assetOrderHeaderDetail?.orderAttachments?.length > 0 ? JSON.parse(JSON.stringify(assetOrderHeaderDetail?.orderAttachments)) : [];
        UploadAttachmentsDispatch.dispatchSetAttachments(dispatch)(orderAttachment);
        let temp = { ...assetDispositionTemp }
        assetOrderHeaderDetail?.fleetRequestDetail?.map((item: any, index: any) => {
            const disposition = item?.assetDisposition;
            const location = item?.physicalAssetLocation;
            temp.assetDispositionChoice = disposition?.dispositionChoiceText
            temp.assetDispositionChoiceId = disposition?.dispositionChoice
            temp.assetDispositionProcessType = getProcessType(disposition?.processType)
            temp.assetDispositionReasonCode = getReasonCode(disposition?.reasonCode) ? getReasonCode(disposition?.reasonCode) : getReasonCode(CONSTANTS.ASSET_DISPOSITION_REASON_CODE_DEFAULT_VALUE)
            temp.assetDispositionReasonCodeId = getReasonCodeId(disposition?.reasonCode) ? getReasonCodeId(disposition?.reasonCode) : getReasonCodeId(CONSTANTS.ASSET_DISPOSITION_REASON_CODE_DEFAULT_VALUE)
            temp.replacementFleetAssetOrder = disposition?.replacementFleetAssetOrder
            temp.replacementFleetAsset = disposition?.replacementFleetAsset
            temp.assetDispositionName = disposition?.name;
            temp.assetDispositionAddress1 = disposition?.address1;
            temp.assetDispositionAddress2 = disposition?.address2;
            temp.assetDispositionState = getValue(disposition?.state)
            temp.assetDispositionCity = getValue(disposition?.city)
            temp.assetDispositionZip = disposition?.zipCode;
            temp.assetDispositionPhone = disposition?.phone;
            temp.assetLocationName = location?.locationName;
            temp.assetLocationContactName = location?.contactName;
            temp.assetLocationAddress1 = location?.address1;
            temp.assetLocationAddress2 = location?.address2;
            temp.assetLocationState = getValue(location?.state)
            temp.assetLocationCity = getValue(location?.city)
            temp.assetLocationZip = location?.zip;
            temp.assetLocationContactPhone = location?.contactPhone;
            temp.assetLocationEmail = location?.email;
            temp.assetDispositionSalePrice = disposition?.salePrice ? formatPrice(disposition?.salePrice, 2) : null;
            temp.assetDispositionTotalPrice = disposition?.totalPrice ? formatPrice(disposition?.totalPrice, 2) : null;
            temp.assetLocationNameError = '';
            temp.assetLocationContactNameError = '';
            temp.assetLocationEmailError = '';
            temp.assetLocationContactPhoneError = '';
            temp.assetLocationAddress1Error = '';
            temp.assetLocationAddress2Error = '';
            temp.assetLocationCityError = '';
            temp.assetLocationStateError = '';
            temp.assetLocationZipError = '';    
            temp.assetDispositionSubChoiceError = '';
            temp.assetDispositionNameError = '';
            temp.assetDispositionAddress1Error = '';
            temp.assetDispositionAddress2Error = '';
            temp.assetDispositionCityError = '';
            temp.assetDispositionStateError = '';
            temp.assetDispositionZipError = null;
            temp.assetDispositionPhoneError = null;
            temp.assetDispositionSalePriceError = null;
            temp.assetDispositionTotalPriceError = null;
            temp.assetDispositionSubChoiceId = disposition?.sellToLeased;
            temp.assetDispositionSubChoice = disposition?.sellToLeasedText; 
            if(temp.assetDispositionChoiceId && choices.includes(temp.assetDispositionChoice)){
                dispatch(getDispositionSubChoice(temp.assetDispositionChoiceId))  
            }
        })
        if (temp?.assetLocationName === assetOrderHeaderDetail?.branchName) {
            setSameAsBranch(true)
            temp.sameAsBranch = true
        } else {
            setSameAsBranch(false)
            temp.sameAsBranch = false
        } 
        dispatch(setDispositionData({ ...temp }))
        dispatch(setInitialDispositionData({...temp}))
        dispatch(getDispositionChoice(assetOrderHeaderDetail?.isLeased))
    }
    }, [assetOrderHeaderDetail])

    useEffect(() => {
        if (assetOrderHeaderDetail?.orderStatus == CONSTANTS.ORDER_STATUS.CANCELLED || assetOrderHeaderDetail?.orderStatus == CONSTANTS.ORDER_STATUS.COMPLETED) {
            setIsAttachmentEditable(false)
        } else {
            setIsAttachmentEditable(true)
        }

    }, [assetOrderHeaderDetail?.orderStatus, savedStatus])

    useEffect(() => {
        if(assetOrderHeaderDetail?.orderRequestId && updateOrderAttachments){
            let payload = {
                orderId: assetOrderHeaderDetail?.orderRequestId,
                attachments: docList,
                savedBy: getUserDetails?.emailId
            }
            dispatch(saveOrderAttachments(payload))
            setUpdateOrderAttachments(false)
        }
        dispatch(setAttachmentList(docList));
    }, [docList]);

    const getSelectedDispositionChoice = (selectedItem: any) => {
        let selectedValue = "";
        dispositionChoiceList?.map((item: any) => {
            if (item.value == selectedItem) {
                selectedValue = item.text
            }
        });
        return selectedValue;
    }
    
    const getProcessType = (selectedItem: any) => {
        let selectedValue = {};
        processTypeOptions?.map((item: any) => {
            if (item.value == selectedItem) {
                selectedValue = { label: item.text, key: item.value, ...item };
            }
        });
        return selectedValue;
    }

    const getSubChoice = (selectedItem: any) => {
        let selectedValue = {};
        dispositionSubChoiceList?.map((item: any) => {
            if (item.value == selectedItem) {
                selectedValue = {...item};
            }
        });
        return selectedValue;
    }

    const getReasonCode = (selectedItem: any) => {
        let selectedValue = '';
        if (selectedItem) {
            reasonCodeList?.map((item: any) => {
                if (item.value == selectedItem) {
                    selectedValue = item.text
                }
            });
        }
        return selectedValue;
    }

    const getReasonCodeId = (selectedItem: any) => {
        let selectedValue = '';
        if (selectedItem) {
            reasonCodeList?.map((item: any) => {
                if (item.value == selectedItem) {
                    selectedValue = item.value
                }
            });
        }
        return selectedValue;
    }

    const getValue = (item: any) => {
        
        return item
    }

    const onChangeDispositionChoice = (selectedItem: any) => {
        const popUpDecriptionTxt = (
            <>
                <p>On changing the disposition choice task list will get reset.</p>
                <p>Are you sure you want to continue?</p>
            </>
        );
        setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: CONSTANTS.TITLE_CONFIRMATION,
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: popUpDecriptionTxt,
            primaryBtnText: "Yes",
            outlineBtnText: "No",
            popupOutlinebtnOnclick: () => {
                setPopupcontent({ ...Popupcontent, isDialogVisible: false })
            },
            popupPrimarybtnOnclick: () => {
                setIsChnagedOccuredFlag(true)
                setPopupcontent({ ...Popupcontent, isDialogVisible: false })
                onClickYes(selectedItem)
            },
            hideDialog: () => {
                setPopupcontent({ ...Popupcontent, isDialogVisible: false })
            },
            isSingleConfirmationBtn: false,
        });
    }

    const onClickYes = (selectedItem: any) => {
        if (FMCAuctionChoices.includes(selectedItem?.text)) {
            dispatch(getDispositionSubChoice(selectedItem?.value))
        }
        const temp = {
            ...assetDispositionTemp,
            assetDispositionChoice: selectedItem?.label,
            assetDispositionChoiceId: selectedItem?.value,
            assetDispositionSubChoice: null,
            assetDispositionSubChoiceId: null,
            assetDispositionName: '',
            assetDispositionAddress1: '',
            assetDispositionAddress2: '',
            assetDispositionCity: '',
            assetDispositionState: '',
            assetDispositionZip: null,
            assetDispositionPhone: null,
            assetDispositionSalePrice: null,
            assetDispositionTotalPrice: null,
            assetDispositionSubChoiceError: '',
            assetDispositionNameError: '',
            assetDispositionAddress1Error: '',
            assetDispositionAddress2Error: '',
            assetDispositionCityError: '',
            assetDispositionStateError: '',
            assetDispositionZipError: null,
            assetDispositionPhoneError: null,
            assetDispositionSalePriceError: null,
            assetDispositionTotalPriceError: null,
        }
        dispatch(setDispositionData({ ...temp }))
        if(selectedItem?.text?.toLowerCase().includes("write-off")){
            setSameAsBranch(false)
            dispatch(setDispositionData({
                ...temp,
                assetLocationName: '',
                assetLocationContactName: '',
                assetLocationEmail: '',
                assetLocationContactPhone: '',
                assetLocationAddress1: '',
                assetLocationAddress2: '',
                assetLocationCity: '',
                assetLocationState: '',
                assetLocationZip: '',
                assetLocationNameError: '',
                assetLocationContactNameError: '',
                assetLocationEmailError: '',
                assetLocationContactPhoneError: '',
                assetLocationAddress1Error: '',
                assetLocationAddress2Error: '',
                assetLocationCityError: '',
                assetLocationStateError: '',
                assetLocationZipError: '',     
        }))
        }
    }

    const onChangeProcessType = (selectedItem: any) => {
        setIsChnagedOccuredFlag(true)
        dispatch(setDispositionData({ ...assetDispositionTemp, assetDispositionProcessType: selectedItem }))
    }

    const onChangeReasonCode = (selectedItem: any) => {
        setIsChnagedOccuredFlag(true)
        let temp = {
            ...assetDispositionTemp,
            assetDispositionReasonCode: selectedItem?.label,
            assetDispositionReasonCodeId: selectedItem?.value,
        }
        dispatch(setDispositionData(temp))
    }

    const assetLocationNameOnChange = (item: any) => {
        setIsChnagedOccuredFlag(true)
        let temp = { ...assetDispositionTemp, assetLocationName: item.target.value }
        const error = LocationValidation.ValidateAssetLocationName(temp, temp)
        dispatch(setDispositionData(error))
    }

    const onChangeContactName = (item: any, type: string) => {
        setIsChnagedOccuredFlag(true)
        if (type === 'assetLocation') {
            let temp = { ...assetDispositionTemp, assetLocationContactName: item.target.value }
            const error = LocationValidation.ValidateName(temp, temp)
            dispatch(setDispositionData(error))
        } else {
            let temp = { ...assetDispositionTemp, assetDispositionName: item.target.value }
            const error = DispositionValidation.ValidateName({ assetDispositionName: item.target.value, assetDispositionChoice: temp?.assetDispositionChoice }, temp)
            dispatch(setDispositionData(error))
        }
    }

    const onChangeEmail = (item: any) => {
        setIsChnagedOccuredFlag(true)
        let temp = { ...assetDispositionTemp, assetLocationEmail: item.target.value }
        const error = LocationValidation.ValidateEmailAddress(temp, temp)
        dispatch(setDispositionData(error))
    }

    const onChangeSubChoice = (item: any) => {
        setIsChnagedOccuredFlag(true)
        let temp = { ...assetDispositionTemp, assetDispositionSubChoice: item.text, assetDispositionSubChoiceId: item.value }
        const error = DispositionValidation.ValidateDispositionSubChoice({ ...temp }, temp)
        dispatch(setDispositionData(error))
    }

    const onChangeSalePrice = (item: any) => {
        setIsChnagedOccuredFlag(true)
        let temp = { ...assetDispositionTemp, assetDispositionSalePrice: item.target.value }
        const error = DispositionValidation.ValidateSalePrice({ ...temp, assetDispositionChoice: temp?.assetDispositionChoice }, temp)
        dispatch(setDispositionData(error))
    }

    const onChangeTotalPrice = (item: any) => {
        setIsChnagedOccuredFlag(true)
        let temp = { ...assetDispositionTemp, assetDispositionTotalPrice: item.target.value }
        const error = DispositionValidation.ValidateTotalPrice({ ...temp, assetDispositionChoice: temp?.assetDispositionChoice }, temp)
        dispatch(setDispositionData(error))
    }

    const TotalpriceFormat = (item: any) => {
        if (item.target.value == 0) {
            return
        }
        const temp = { ...assetDispositionTemp }
        temp.assetDispositionTotalPrice = formatPrice(item.target.value, 2)
        dispatch(setDispositionData(temp))
    };

    const priceFormat = (item: any) => {
        if (item.target.value == 0) {
            return
        }
        const temp = { ...assetDispositionTemp }
        temp.assetDispositionSalePrice = formatPrice(item.target.value, 2)
        dispatch(setDispositionData(temp))
    };

    const onChangeAddress2 = (selectedItem: any, type: string) => {
        setIsChnagedOccuredFlag(true)
        if (type === 'assetLocation') {
            let temp = { ...assetDispositionTemp, assetLocationAddress2: selectedItem.target.value }
            const error = LocationValidation.ValidateAddress2(temp, temp)
            dispatch(setDispositionData(error))
        } else {
            let temp = { ...assetDispositionTemp, assetDispositionAddress2: selectedItem.target.value }
            const error = DispositionValidation.ValidateAddress2({ ...temp, assetDispositionChoice: temp?.assetDispositionChoice }, temp)
            dispatch(setDispositionData(error))
        }
    }
    const onChangeState = (e: any, selectedItem: any, type: string) => {
        setIsChnagedOccuredFlag(true)
        if (type === 'assetLocation') {
            let temp = {
                ...assetDispositionTemp,
                assetLocationState: e.target.value,
                assetLocationStateError: ''
            }
            let error = { ...LocationValidation.ValidateState(temp , temp) };
            dispatch(setDispositionData(error))
        } else {
            let temp = {
                ...assetDispositionTemp,
                assetDispositionState: e.target.value,
                assetDispositionStateError: ''
            }
            let error = { ...DispositionValidation.ValidateState({ ...temp, assetDispositionChoice: temp?.assetDispositionChoice }, temp) };
            dispatch(setDispositionData(error))
        }
    }

    const onChangeCity = (e:any, selectedItem: any, type: string) => {
        setIsChnagedOccuredFlag(true)
        if (type === 'assetLocation') {
            let temp = { ...assetDispositionTemp, assetLocationCity: e.target.value }
            let error = { ...LocationValidation.ValidateCity(temp, temp) };
            dispatch(setDispositionData(error))
        } else {
            let temp = { ...assetDispositionTemp, assetDispositionCity: e.target.value  }
            let error = { ...DispositionValidation.ValidateCity({ ...temp, assetDispositionChoice: temp?.assetDispositionChoice }, temp) };
            dispatch(setDispositionData(error))
        }
    }

    const onChangePhoneNumber = (value: any, type: string) => {
        setIsChnagedOccuredFlag(true)
        if (type === 'assetLocation') {
            let temp = { ...assetDispositionTemp, assetLocationContactPhone: value }
            let error = { ...LocationValidation.ValidatePhone(temp, temp) };
            dispatch(setDispositionData(error))
        } else {
            let temp = { ...assetDispositionTemp, assetDispositionPhone: value }
            let error = { ...DispositionValidation.ValidatePhone({ ...temp, assetDispositionChoice: temp?.assetDispositionChoice }, temp) };
            dispatch(setDispositionData(error))
        }
    }

    const onChangeZipCode = (selectedItem: any, type: string) => {
        setIsChnagedOccuredFlag(true)
        const val = selectedItem.target.value
        const regEx = /^[\d\.?\d,\b]*$/;
        const valArr = val.split('.')
        const checkNumber = regEx.test(val);
        if (!checkNumber || valArr.length > 2) {
            return;
        }
        else {
            if (type === 'assetLocation') {
                let temp = { ...assetDispositionTemp, assetLocationZip: selectedItem.target.value }
                let error = { ...LocationValidation.ValidateZip(temp, temp) };
                dispatch(setDispositionData(error))
            } else {
                let temp = { ...assetDispositionTemp, assetDispositionZip: selectedItem.target.value }
                let error = { ...DispositionValidation.ValidateZip({ ...temp, assetDispositionChoice: temp?.assetDispositionChoice }, temp) };
                dispatch(setDispositionData(error))
            }
        }
    }

    const toggleSameAsBranch = () => {
        setIsChnagedOccuredFlag(true)
        let temp: any = {}
        if (!sameAsBranch) {
            const selectedBranchDetails = branchTypeDropdown.find((branchItem: any) => branchItem?.branchName === assetOrderHeaderDetail?.branchName)
            let error = {
                ...assetDispositionTemp,
                assetLocationName: selectedBranchDetails.branchName?.trim(),
                assetLocationContactPhone: selectedBranchDetails.branchPhone,
                assetLocationAddress1: selectedBranchDetails.branchAddress3?.trim(),
                assetLocationAddress2: selectedBranchDetails.branchAddress2?.trim(),
                assetLocationZip: selectedBranchDetails.branchZip?.trim(),
                assetLocationState: getValue(selectedBranchDetails.branchState?.trim()),
                assetLocationCity: getValue(selectedBranchDetails.branchCity?.trim()),
                assetLocationContactName: '',
                assetLocationEmail: '',
            }
            temp = validateLocation(error);
        } else {
            let error = {
                ...assetDispositionTemp,
                assetLocationName: '',
                assetLocationContactName: '',
                assetLocationEmail: '',
                assetLocationContactPhone: '',
                assetLocationAddress1: '',
                assetLocationAddress2: '',
                assetLocationZip: '',
                assetLocationState: '',
                assetLocationCity: ''
            }
            temp = validateLocation(error);
        }
        setSameAsBranch(!sameAsBranch)
        temp.sameAsBranch = !sameAsBranch
        dispatch(setDispositionData(temp))
    }

    const validateLocation = (location: any) => {
        location = { ...LocationValidation.ValidateAssetLocationName(location, location) };
        location = { ...LocationValidation.ValidateName(location, location) };
        location = { ...LocationValidation.ValidateEmailAddress(location, location) };
        location = { ...LocationValidation.ValidatePhone(location, location) };
        location = { ...LocationValidation.ValidateAddress1(location, location) };
        location = { ...LocationValidation.ValidateCity({ ...location, assetLocationCity: location?.assetLocationCity }, location) };
        location = { ...LocationValidation.ValidateState({ ...location, assetLocationState: location?.assetLocationState }, location) };
        location = { ...LocationValidation.ValidateZip(location, location) };
        location = { ...LocationValidation.ValidateAddress2(location, location) };
        return location;
    }

    const isUploaded = (name: string) =>
        attachmentsList.find((x: any) => getFileName(x.attachmentUrl) === name);

    const onUploadClick = (fileList: Array<File>) => {
        setAttachmentError("");
        const filteredList = [
            ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
        ];
        if (filteredList.length > 0 && filteredList.length <= 5) {
            setAttachmentError("");
            let totalSize = 0;
            filteredList.forEach((file: File) => {
                totalSize = totalSize + (file.size || 0);
            });
            if (totalSize <= 5000000) {
                setAttachmentError("");
                const formData = new FormData();
                formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

                for (let i = 0; i < filteredList.length; i++) {
                    formData.append("Files", filteredList[i] as any);
                }
                dispatchUploadAttachments({ formData, filteredList, list: attachmentsList });
                setUpdateOrderAttachments(true)
            } else {
                setAttachmentError("Please Upload files without exceeding maximum size of 5MB");
            }
        } else if (fileList.length > 5) {
            setAttachmentError(
                "Please Upload files without exceeding maximum limit of 5 files"
            );
        } else {
            if (fileList.length > 0 && !filteredList.length) {
                setAttachmentError("All files are uploaded try to add new files");
            } else {
                setAttachmentError("Choose at least 1 file to upload");
            }
        }
    };

    const onRemoveAttachment = (index: any) => {
        const findattachment = attachmentsList?.find((_attachment: any, i: any) => index === i);
        const assetArr = [];
        if (findattachment) {
            for (let i = 0; i < linkedAttachments?.length; i++) {
                linkedAttachments[i]?.attachments?.forEach((assetVal: any) => {
                    const findAttch = (assetVal?.fileName === findattachment?.fileName);
                    if (findAttch) {
                        assetArr.push(assetVal)
                    }
                })
            }
        }
        if (assetArr?.length) {
            setAttachmentError("The attachment file cannot be deleted. File linked to the item.");
        }
        else {
            const newArr = attachmentsList.slice();
            newArr.splice(index, 1);
            const newFileList = [...documentList];
            newFileList.splice(index, 1);
            setDocumentList(newFileList);
            dispatchRemoveAttachment(newArr);
            setAttachmentError("");
            setUpdateOrderAttachments(true)
        }
    }

    const isDispFieldDisable = () => {
        let isCompleted: any = [];
        if(assetOrderHeaderDetail?.orderStatus == CONSTANTS.ORDER_STATUS.COMPLETED || assetOrderHeaderDetail?.orderStatus == CONSTANTS?.ORDER_STATUS.CANCELLED){
            isCompleted.push(assetOrderHeaderDetail)
        }
        if (isCompleted?.length) {
            return true
        } else {
            return false
        }

    }

    const onChangeAddress1 = (e: any, item?: any, typeVal?: any) => {
        setCurrentType(typeVal)
        dispatch(getAddressDetails(e?.key))
    }

    useEffect(() => {
        if (addressSearchText?.length > 3) {
            setAddressListLoad(true)
            dispatch(getAddressDropDownList(addressSearchText.replace(/[^\w\s]/gi, "")));
        }

    }, [addressSearchText])

    const filterdispositionOptionAddress1 = (value: any, action: any, type:any) => {
        if (action.action === "input-change") {
            setCurrentType(type)
            setAddressSearchText(value);
            setIsChnagedOccuredFlag(true)
        if (type === 'assetLocation') {
            let temp = { ...assetDispositionTemp, assetLocationAddress1: value }
            const error = LocationValidation.ValidateAddress1(temp, temp)
            dispatch(setDispositionData(error))
        } else {
            let temp = { ...assetDispositionTemp, assetDispositionAddress1: value }
            const error = DispositionValidation.ValidateAddress1({ ...temp, assetDispositionChoice: temp?.assetDispositionChoice }, temp)
            dispatch(setDispositionData(error))
        }
        }
    };

    useEffect(() => {
        if (locationAddressDetails?.hasOwnProperty("address1") || locationAddressDetails?.hasOwnProperty("address2")) {
          setAddressSearchText('')
          let temp: any = {}
          if(currentType == "assetLocation"){
          let error = {
            ...assetDispositionTemp,
            assetLocationAddress1: locationAddressDetails?.address1,
            assetLocationAddress2: locationAddressDetails?.address2,
            assetLocationZip: locationAddressDetails?.postalCode,
            assetLocationState: locationAddressDetails?.state,
            assetLocationCity: locationAddressDetails?.city
        }
        temp = validateLocation(error);
    }else{
        let error = {
            ...assetDispositionTemp,
            assetDispositionAddress1: locationAddressDetails?.address1,
            assetDispositionAddress2: locationAddressDetails?.address2,
            assetDispositionZip: locationAddressDetails?.postalCode,
            assetDispositionState: locationAddressDetails?.state,
            assetDispositionCity: locationAddressDetails?.city
        }
        temp = validateLocation(error);
    }
        dispatch(setDispositionData(temp))
        }
      }, [locationAddressDetails])

    const getOrderQty = useCallback(() => {
        return Number(assetOrderHeaderDetail?.quantity || 0).toString()
    }, [assetOrderHeaderDetail, savedStatus])

    return (
        <RequestDetails
            assetOrderHeaderDetail={assetOrderHeaderDetail}
            processTypeOptions={processTypeOptions}
            dispositionChoiceDropdownList={dispositionChoiceDropdownList}
            reasonCodeDropdownList={reasonCodeDropdownList}
            stateDropdownList={stateDropdownList}
            cityDropdownList={cityDropdownList}
            branchValue={branchValue}
            onChangeDispositionChoice={onChangeDispositionChoice}
            thirdPartyChoices={thirdPartyChoices}
            FMCAuctionChoices={FMCAuctionChoices}
            assetDisposition={assetDisposition}
            onChangeProcessType={onChangeProcessType}
            onChangeReasonCode={onChangeReasonCode}
            assetLocationNameOnChange={assetLocationNameOnChange}
            onChangeState={onChangeState}
            onChangeContactName={onChangeContactName}
            onChangeEmail={onChangeEmail}
            sameAsBranch={sameAsBranch}
            toggleSameAsBranch={toggleSameAsBranch}
            onChangeSubChoice={onChangeSubChoice}
            onChangeCity={onChangeCity}
            onChangeAddress1={onChangeAddress1}
            onChangeAddress2={onChangeAddress2}
            onChangePhoneNumber={onChangePhoneNumber}
            onChangeZipCode={onChangeZipCode}
            dispositionSubChoiceDropdownList={dispositionSubChoiceDropdownList}
            onChangeSalePrice={onChangeSalePrice}
            onUploadClick={onUploadClick}
            onRemoveAttachment={onRemoveAttachment}
            setAttachmentError={setAttachmentError}
            attachmentError={attachmentError}
            setDocumentList={setDocumentList}
            documentList={documentList}
            attachmentsList={attachmentsList}
            Popupcontent={Popupcontent}
            priceFormat={priceFormat}
            iAttachmentEditable={iAttachmentEditable}
            TotalpriceFormat = {TotalpriceFormat}
            onChangeTotalPrice = {onChangeTotalPrice} 
            isDispFieldDisable={isDispFieldDisable}
            addressDropDownListTemp = {addressDropDownListTemp}
            addressListLoad = {addressListLoad}
            addressSearchText = {addressSearchText}
            filterdispositionOptionAddress1 = {filterdispositionOptionAddress1}
            getOrderQty = {getOrderQty}
        />
    )
}

export default RequestDetailsContainer;